import {useEffect, useState} from "react";
import {getAzureFilesReport} from "../../../azureFiles.services";

const useAzureFilesReport = () => {
  const [date, setDate] = useState(null);
  const [structure, setStructure] = useState(null);
  const [data, setData] = useState({});

  useEffect(() => {
    async function getReportByDate(){
      const [status, report] = await getAzureFilesReport(date);
      console.log(report)
      if (status) {
        const {data: d, structure: s} = report;
        setData(d);
        setStructure(s);
        console.log("Data")
        console.log(d)

        console.log("Structure")
        console.log(s)
      }
    }

    if (date) {
      getReportByDate();
    }
  }, [date]);


  return {
    date,
    data,
    structure,
    setDate
  }
}

export default useAzureFilesReport